module.exports = __webpack_public_path__ + "img/symbol_15.b12bfa3f.png";